import React from 'react';
import PropTypes from 'prop-types';
import DataTable from './shared/DataTable';
import NftsBalanceRow from './NftsBalanceRow';
import NftsBalanceTableHeader from './NftsBalanceTableHeader';

const NftsBalanceTable = ({ nftsData = [], size, offset, sort, order, totalCount, loadData, isHomePage, filters }) => {
	const nftsDataRows = nftsData.map((nftData, index) => (
		<NftsBalanceRow key={index} nftData={nftData} isHomePage={isHomePage} filters={filters}/>
	));
	return (
		<DataTable
			limit={size}
			offset={offset}
			sort={sort}
			order={order}
			totalCount={totalCount}
			header={NftsBalanceTableHeader}
			rows={nftsDataRows}
			loadData={loadData}
		/>
	);
};

export default NftsBalanceTable;

NftsBalanceTable.propTypes = {
	// totalCount: PropTypes.number.isRequired,
	loadData: PropTypes.func.isRequired
};
